<script>
import { mapActions } from "vuex";

export default {
  mounted() {
    this.tokenCheck();
  },

  methods: {
    ...mapActions({
      tokenCheck: "app/tokenCheck"
    })
  }
};
</script>
